/**
 * Level 100's boss (02 §9.4): made by `spawnMonsters` on level 100, moved on I-ticks (`bossITick`,
 * D_1D84), hit and stunned on M-ticks (`boltHitsBoss`, `bossMTick`, $1134). See move.ts and hits.ts.
 */

import { BOSS } from '../tuning';
import type { Facing, World } from '../../types';

export { bossITick, makeBoss } from './move';
export { bossMTick, boltHitsBoss } from './hits';

/** What the renderer draws of the boss. */
export interface BossLook {
  /**
   * The C64's sprite registers of its top-left sprite (VIC frame). The boss is 3 x 3 sprites, 72 x 63 px:
   * its picture's top-left in playfield pixels is (x - 24, y - 50) (the 16x16 bodies of the other
   * sprites sit 4 px in and 5 px down from their sprite's corner: x - 20, y - 45).
   */
  x: number;
  y: number;
  /** Draw it at all: false before the READY banner goes, while blinked off late in a stun, once beaten. */
  visible: boolean;
  /** Its stunned picture ($BE = 9): touch it to win. */
  stunned: boolean;
  /** Its picture set: -1 facing left ($BE = 0, as it starts), 1 facing right ($BE = $18). */
  facing: Facing;
  /** C64 colour: 5 green, 10 light red once it has recovered from a stun (angry, twice as fast). */
  colour: number;
}

/** The boss as the renderer draws it, or null when this level has none. */
export function bossLook(world: World): BossLook | null {
  const b = world.boss;
  if (!b) return null;
  return {
    x: b.x, y: b.y, visible: !b.blink && b.state !== 'beaten', stunned: b.state === 'stunned',
    facing: b.ai.face === 0 ? -1 : 1, colour: b.angry ? BOSS.angryColour : BOSS.colour,
  };
}
